export function convertScale(value, fromScale, toScale) {
  const numericValue = Number(value);
  const source = Number(fromScale);
  const target = Number(toScale);

  if (!Number.isFinite(numericValue) || !Number.isFinite(source) || !Number.isFinite(target)) {
    return { error: 'Please enter valid numeric values.' };
  }

  if (source <= 0 || target <= 0) {
    return { error: 'Scale values must be greater than 0.' };
  }

  if (numericValue < 0 || numericValue > source) {
    return { error: 'Input value must be between 0 and the selected source scale.' };
  }

  return {
    value: (numericValue / source) * target
  };
}
